module.exports = __webpack_public_path__ + "static/media/meals-and-drinks.08f3e385.svg";